import type { QueryClient } from '@tanstack/react-query';

import { TRANSACTION_VIEW_QUERY_KEYS } from '@/api/transaction-views/queries';

export const invalidateTransactionViews = (queryClient: QueryClient) =>
  Promise.all([
    queryClient.invalidateQueries({
      queryKey: [TRANSACTION_VIEW_QUERY_KEYS.transactions],
    }),
    queryClient.invalidateQueries({
      queryKey: [TRANSACTION_VIEW_QUERY_KEYS.transaction],
    }),
  ]);
